<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Michael A. Orona is originally from the Southwestern United States. He is of Chihene Nde (Apache) and Yaqui ancestry. For over two decades he has traveled the world promoting human rights and currently makes his home in the Washington, DC area.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4555cb7f